"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _moment = _interopRequireDefault(require("moment"));

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledAppIcon = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  width: 120px;\n  height: 120px;\n  margin: 2rem auto;\n"])));

var Login = function Login(_ref) {
  var translations = _ref.translations,
      hideBackButton = _ref.hideBackButton,
      onError = _ref.onError,
      onLoginSuccess = _ref.onLoginSuccess,
      appIconUrl = _ref.appIconUrl,
      geoLocationCity = _ref.geoLocationCity,
      isLoading = _ref.isLoading;

  if (!translations) {
    translations = _defaultTranslations.default;
  }

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      serverError = _useState2[0],
      setError = _useState2[1];

  var validate = function validate(values) {
    var errors = {}; // if (!values.email) {
    //   errors.email = "Email Required";
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    //   errors.email = "Invalid email address";
    // }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    localStorage.removeItem("fiver_react_access_token");
    delete _axios.default.defaults.headers.common["Authorization"];

    _axios.default.post("/auth/login", {
      username: values.username,
      password: values.password
    }).then(function (_ref3) {
      var data = _ref3.data;
      var access_token = data.access_token;
      _axios.default.defaults.headers.common["Authorization"] = "Bearer ".concat(access_token);

      _axios.default.get("/me").then(function (_ref4) {
        var data = _ref4.data;
        setSubmitting(false);
        var profile = data.data;
        var age = (0, _moment.default)().diff((0, _moment.default)(profile === null || profile === void 0 ? void 0 : profile.birthDate, "YYYY-MM-DD"), "years", true);
        var isOver24 = age >= 24;
        onLoginSuccess({
          accessToken: access_token,
          isOver24: isOver24
        });
        localStorage.removeItem("fiver_react_gdpr_required");
        window.xtremepush("set", "user_id", profile.id); // window.xtremepush("user", "update", {
        //   user_id: profile.id,
        //   email: profile.email,
        //   mobile_number: profile.mobileNumber,
        //   first_name: profile.firstName,
        //   last_name: profile.lastName,
        //   birth_date: profile.birthDate,
        //   age,
        //   isOver24,
        //   tenant_id: process.env.REACT_APP_TENANT,
        //   username: profile.username,
        //   sms_subscription:
        //     profile.contactPermissions.smsNotificationsAccepted,
        //   email_subscription:
        //     profile.contactPermissions.emailNotificationsAccepted,
        //   push_subscription:
        //     profile.contactPermissions.inAppNotificationsAccepted,
        // });

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appInterface) {
          window.webkit.messageHandlers.appInterface.postMessage(JSON.stringify({
            profileId: profile.id
          }));
        }

        if (window.appInterface) {
          window.appInterface.postMessage(JSON.stringify({
            profileId: profile.id
          }));
        }
      }).catch(function (error) {
        setSubmitting(false);
        onError(error);
      });
    }).catch(function (_ref5) {
      var _response$data, _response$data2, _response$data3;

      var response = _ref5.response;
      setSubmitting(false);
      localStorage.removeItem("fiver_react_access_token");

      if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === "userIsSelfExcluded" || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === "userNeedsToBeReactivated" || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === "userIsCoolingOff") {
        //todo translate back end error messages
        setError("".concat(translations.invalid, " ").concat(translations.username, "/").concat(translations.password));
      } else {
        setError("".concat(translations.invalid, " ").concat(translations.username, "/").concat(translations.password));
      }
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAppIcon, {
        src: appIconUrl
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
        initialValues: {
          username: "",
          password: ""
        },
        validate: validate,
        onSubmit: onSubmit,
        children: function children(_ref6) {
          var isValid = _ref6.isValid,
              values = _ref6.values,
              errors = _ref6.errors,
              touched = _ref6.touched,
              dirty = _ref6.dirty,
              handleChange = _ref6.handleChange,
              handleBlur = _ref6.handleBlur,
              handleSubmit = _ref6.handleSubmit,
              isSubmitting = _ref6.isSubmitting;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Form, {
            onSubmit: handleSubmit,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                type: "text",
                name: "username",
                placeholder: translations.username,
                onChange: handleChange,
                onBlur: handleBlur,
                value: values.username
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                type: "password",
                name: "password",
                placeholder: translations.password,
                onChange: handleChange,
                onBlur: handleBlur,
                value: values.password
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.FormRowMessage, {
              isVisible: !isValid && touched || serverError,
              children: [errors.username && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: errors.username
              }), serverError && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: serverError
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                padding: "40px 0"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.TextButton, {
                to: "/forgot",
                children: [translations.forgotPassword || "".concat(translations.forgot, " ").concat(translations.password), "?"]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              style: {
                marginBottom: "1rem"
              },
              type: "submit",
              isLoading: isSubmitting || isLoading,
              disabled: !dirty || isSubmitting || !isValid,
              children: translations.login
            }), !hideBackButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
              type: "button",
              to: "/",
              isDefault: true,
              children: translations.back
            })]
          });
        }
      })]
    })
  });
};

Login.defaultProps = {
  isBackgroundDark: false
};
Login.propTypes = {
  isBackgroundDark: _propTypes.default.bool
};
var _default = Login;
exports.default = _default;